
import { IconTextGridCell } from '@/shared/components/GridTable/GridCells/IconTextGridCell'
import { GridColDef } from '@mui/x-data-grid-premium'

export const addRunDialogColumnDefs: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 100,
    renderCell: (params) => (<IconTextGridCell {...params} />), 
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 100,
  },
  {
    field: 'displayRunAttributes',
    headerName: 'Attributes',
    width: 100,
  },
  {
    field: 'startDepot',
    headerName: 'Start Depot',
    width: 100,
  },
  {
    field: 'finishDepot',
    headerName: 'Finish Depot',
    width: 100,
  },
  {
    field: 'startTimeEarliest',
    headerName: 'Earliest Start Time',
    width: 90,
  },
  {
    field: 'startTimeLatest',
    headerName: 'Latest Start Time',
    width: 75,
  },
  {
    field: 'weightCapacity',
    headerName: 'Weight Capacity',
    width: 75,
  },
  {
    field: 'volumeCapacity',
    headerName: 'Volume Capacity',
    width: 85,
  },
  {
    field: 'costFixed',
    headerName: 'Fixed Cost',
    width: 75,
  },
  {
    field: 'costPerHour',
    headerName: 'Cost Per Hour',
    width: 90,
  },
  {
    field: 'costPerKm',
    headerName: 'Cost Per Km',
    width: 90,
  },
  {
    field: 'maxWorkingTime',
    headerName: 'Max Working Time',
    width: 125,
  },
  {
    field: 'maxDrivingTime',
    headerName: 'Max Driving Time',
    width: 125,
  },
  {
    field: 'isActive',
    headerName: 'Status',
    width: 100,
  },
]